import QUERY from 'lodash'

export default {

  data () {
    return {
      requesterSignatory: {
        stage: 0,
        approver_label: 'Logistics Officer - Origin',
        approver_action: 'Authority to Withdraw',
        approver_name: '',
        last_seen: '',
        status: 'Requested',
        status_at: '',
        remarks: ''
      },
      canceledSignatory: {
        stage: 1,
        approver_label: 'Logistics Officer - Origin',
        approver_action: 'Cancellation',
        approver_name: '',
        last_seen: '',
        status: 'Canceled',
        status_at: '',
        remarks: ''
      }
    }
  },

  computed: {
    SubmitRequestAsDraftButton () {
      if (this.editing) {
        return 'Update Draft'
      }

      return 'Save Draft'
    }
  },

  methods: {

    vTabStockRequest () {
      if (this.$refs.formStockRequest) {
        return Object.keys(this.$refs.formStockRequest.errors).find(
          key => this.$refs.formStockRequest.errors[key]?.length > 0
        )
      }

      return false
    },

    vTabProducts () {
      if (this.$refs.formProducts) {
        return Object.keys(this.$refs.formProducts.errors).find(
          key => this.$refs.formProducts.errors[key]?.length > 0
        )
      }

      return false
    },

    vTabWithdrawalDetails () {
      if (this.$refs.formWithdrawal) {
        return Object.keys(this.$refs.formWithdrawal.errors).find(
          key => this.$refs.formWithdrawal.errors[key]?.length > 0
        )
      }

      return false
    },

    showRequest (stockRequest, editAsDraft = true) {
      this.editing = true
      this.editAsDraft = editAsDraft

      const { headers, pickup_details, details } = stockRequest

      this.editable.supplier = headers.supplier
      this.editable.destination = headers.destination

      this.editable.is3pl = String(pickup_details?.is_3pl) || 0

      this.stockRequest.headers.withdrawal_type = ''

      this.getProducts(this).finally(() => {
        this.stockRequest = Object.assign(this.stockRequest, {
          id: stockRequest.id,
          stage: 0,
          references: {
            document_number: '',
            transfer_number: '',
            sap_doc_entry: '',
            transaction_number: ''
          },
          headers: {
            withdrawal_type: headers.withdrawal_type,
            destination: '',
            destination_name: '',
            destination_code: '',
            supplier: '',
            supplier_name: '',
            supplier_code: ''
          },
          pickup_details: {
            date: pickup_details?.date || '',
            vehicle: pickup_details?.vehicle || '',
            vehicle_plate: pickup_details?.vehicle_plate || '',
            vehicle_name: pickup_details?.vehicle_name || '',
            driver: pickup_details?.driver || '',
            driver_name: pickup_details?.driver_name || '',
            mobile_number: pickup_details?.mobile_number || '',
            is_3pl: String(pickup_details?.is_3pl) || 0,
            helper: pickup_details?.helper || ''
          },
          details: details.map(
            detail => Object.assign(detail, {
              product: QUERY.find(this.options.products, {
                product_code: detail.product_code
              })
            })
          ),
          approvals: [],
          remarks: headers.remarks,
          created_at: ''
        })

        if (Number(pickup_details?.is_3pl) === 0) {
          this.getDrivers(this).finally(() => {
            this.selected.driver = QUERY.find(this.options.drivers, {
              id: pickup_details?.driver || ''
            }) || ''
          })

          this.getVehicles(this).finally(() => {
            this.selected.vehicle = QUERY.find(this.options.vehicles, {
              id: pickup_details?.vehicle || ''
            }) || ''
          })
        } else {
          this.selected.driver = ''
          this.selected.vehicle = ''
        }

        this.$refs.srDraft.loaded()
        this.$bvModal.show('modalRequest')
      })
    },

    showRequestPreview (stockRequest) {
      const { pickup_details } = stockRequest

      this.editable.is3pl = String(pickup_details?.is_3pl) || 0

      this.stockRequest = Object.assign(this.stockRequest, {
        id: stockRequest.id,
        stage: stockRequest.stage,
        references: {
          document_number: stockRequest.document_number,
          transfer_number: stockRequest.transfer_number,
          sap_doc_entry: stockRequest.sap_doc_entry,
          transaction_number: stockRequest.transaction_number
        },
        headers: {
          withdrawal_type: stockRequest.withdrawal_type,
          supplier: stockRequest.supplier_id,
          supplier_code: stockRequest.supplier_code,
          supplier_name: stockRequest.supplier_name,
          destination: stockRequest.destination_id,
          destination_code: stockRequest.destination_code,
          destination_name: stockRequest.destination_name
        },
        pickup_details: {
          date: pickup_details?.date || '',
          vehicle: pickup_details?.vehicle || '',
          vehicle_plate: pickup_details?.vehicle_plate || '',
          vehicle_name: pickup_details?.vehicle_name || '',
          driver: pickup_details?.driver || '',
          driver_name: pickup_details?.driver_name || '',
          mobile_number: pickup_details?.mobile_number || '',
          logistics_type: Number(pickup_details?.is_3pl) === 1 ? '3rd Party' : 'In-House',
          is_3pl: pickup_details?.is_3pl || 0,
          helper: pickup_details?.helper || ''
        },
        details: stockRequest.withdrawal_details,
        approvals: stockRequest.approvals,
        remarks: stockRequest.remarks,
        created_at: stockRequest.created_at
      })

      this.requesterSignatory = Object.assign(this.requesterSignatory, {
        approver_name: stockRequest.origin_name,
        status_at: stockRequest.created_at
      })

      this.canceledSignatory = Object.assign(this.canceledSignatory, {
        approver_name: stockRequest.origin_name,
        remarks: stockRequest.canceled_remarks,
        status: stockRequest.status,
        status_at: stockRequest.canceled_at
      })

      this.$bvModal.show('modalRequestPreview')
    }
  }
}
